import { ParsedUrlQuery } from 'querystring';
import React from 'react';
import styled from 'styled-components';

interface Props {
  parsedQs: ParsedUrlQuery;
}

const Debugger: React.FC<Props> = ({ parsedQs }) => {
  const showDebugger = parsedQs.log === 'true';

  if (!showDebugger) {
    return null;
  }

  return <DebuggerButton href="#modal-debugger">🐞</DebuggerButton>;
};

const DebuggerButton = styled.a`
  position: fixed;
  bottom: 30px;
  right: 25px;
  background: ${({ theme }) => theme.primaryColor};
  padding: 15px;
  border-radius: 50px;
  cursor: pointer;
  font-size: 25px;
  height: 65px;
  width: 65px;
  text-align: center;
  z-index: 9999;
`;

export default Debugger;
